import type {ReactNode} from 'react';
import React from 'react';
import Head from 'next/head';
import {useTranslation} from 'next-i18next';
import {useReportWebVitals} from 'next/web-vitals';
import eventLogs from '@lib/logcenter/eventLog';
import {useUser} from '@providers/UserProvider';

type Props = {
	children?: ReactNode;
};

const Layout: React.FC<Props> = ({children}) => {
	const {t} = useTranslation();
	const {user} = useUser();

	useReportWebVitals((metric) => {
		eventLogs.logWebVitals(metric, {
			userId: user?.id ?? '',
			navigationType: metric.navigationType,
			rating: metric.rating,
		});
	});

	return (
		<>
			<Head>
				<title>{t('shakerearlyaccesslanding_text_seotitle_web')}</title>
				<meta charSet="utf-8" />
				<meta name="viewport" content="initial-scale=1.0, width=device-width" />
			</Head>
			{children}
		</>
	);
};

export default Layout;
